const membershipSkus = {
  monthly: 'ifmmse',
  yearly: 'ifmysekit102'
};

export function getPaymentData(paymentType, hasFreeTrial) {
  let kitOrItemId;
  if (hasFreeTrial) {
    kitOrItemId = paymentType === 'yearly' ? '5a21ad342fbf010047f44320' : '5a21acd6ad9f260047dbc5d9';
  } else {
    kitOrItemId = paymentType === 'yearly' ? '59e53fa903a25c0040caf2e2' : '59e53dee034ecc0046aed148';
  }

  return {
    paymentType,
    kitOrItemId,
    membershipSku: membershipSkus[paymentType]
  };
}
